import { Box } from '@mui/material';

import Block from '../../../../../components/Block';

import { Campaign } from '../../../../../types/Campaign';
import { useCampaignPageContext } from '../../../../../hooks/Contexts/Pages/CampaignPageContext';
import CampaignFlightsSummaryTable from '../Table/CampaignFlightsSummaryTable';
import CampaignFlightsSummaryCard from '../Card/CampaignFlightsSummaryCard';
import { useMemo } from 'react';
import moment from 'moment-timezone';

const CampaignFlightsPageTab = () => {
    const { campaign, setCampaign } = useCampaignPageContext();

    const liveFlights = useMemo(() => {
        const now = moment.tz('America/New_York').startOf('month');

        return campaign.flights.filter((flight) => {
            const start = moment.tz(flight.startDateTime, 'America/New_York').add(1, 'day').startOf('month');
            const end = moment.tz(flight.endDateTime, 'America/New_York').subtract(1, 'day').startOf('month');

            return !now.isBefore(start) && !now.isAfter(end);
        });
    }, [campaign.flights]);

    const liveFlightNumbers = useMemo(() => {
        return liveFlights
            .map((flight) => {
                const index = campaign.flights.findIndex((f) => f.id === flight.id);
                return index !== -1 ? campaign.flights.length - index : null;
            })
            .filter((n): n is number => n !== null);
    }, [liveFlights, campaign.flights]);

    return (
        <Box>
            <Block>
                <CampaignFlightsSummaryCard
                    campaign={campaign}
                    liveFlights={liveFlights}
                    liveFlightNumbers={liveFlightNumbers}
                />
            </Block>
            <Block>
                <CampaignFlightsSummaryTable
                    campaign={campaign}
                    onChange={(nextCampaign: Campaign): void => {
                        setCampaign({ ...nextCampaign });
                    }}
                />
            </Block>
        </Box>
    );
};

export default CampaignFlightsPageTab;
